function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  className: "ArrowDown_svg__c1",
  d: "M137.3-195c0 17.4 7.4 34.7 19.8 47.1l441.4 409.1c27.3 24.8 71.9 24.8 99.2 0l438.9-429c27.3-24.8 27.3-66.9 0-91.7-27.3-24.8-71.9-24.8-99.2 0L648.1 122.3 256.3-242.2c-27.3-24.8-71.9-24.8-99.2 0-12.4 14.9-19.8 29.8-19.8 47.2z"
});

function SvgArrowDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "135.1 -517.4 1024 1024",
    width: 12,
    height: 12
  }, props), _ref);
}

export default "data:image/svg+xml,%3Csvg version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' viewBox='135.1 -517.4 1024 1024' xml:space='preserve' width='12px' height='12px'%3E %3Cpath class='c1' d='M137.3-195c0,17.4,7.4,34.7,19.8,47.1l441.4,409.1c27.3,24.8,71.9,24.8,99.2,0l438.9-429 c27.3-24.8,27.3-66.9,0-91.7c-27.3-24.8-71.9-24.8-99.2,0L648.1,122.3L256.3-242.2c-27.3-24.8-71.9-24.8-99.2,0 C144.7-227.3,137.3-212.4,137.3-195z'/%3E %3C/svg%3E";
export { SvgArrowDown as ReactComponent };